import React from 'react'
import { Box, Heading, Text, Table, Link } from '@workwhile/ui'
import { ColumnDef } from '@tanstack/react-table'
import { usePendingEvereePayments } from 'queries/w2/usePendingEvereePayments'
import { PendingEvereePayment } from 'api/w2/payments'

export default function PendingPayments() {
  const { data = [], isLoading, error } = usePendingEvereePayments()

  const columns: ColumnDef<PendingEvereePayment>[] = [
    { header: 'ID', accessorKey: 'id' },
    {
      header: 'User',
      accessorFn: (row) =>
        row.userName || (row.userId ? String(row.userId) : ''),
      cell: ({ row }) => {
        const { userId, userName } = row.original
        return userId ? (
          <Link to={`/users/${userId}`}>{userName || `User ${userId}`}</Link>
        ) : (
          '-'
        )
      },
    },
    {
      header: 'Shift',
      accessorKey: 'shiftId',
      cell: ({ row }) => {
        const sid = row.original.shiftId
        return sid ? <Link to={`/shifts/${sid}`}>{sid}</Link> : '-'
      },
    },
    {
      header: 'Amount',
      accessorKey: 'amount',
    },
    { header: 'Status', accessorKey: 'status' },
    { header: 'Provider', accessorKey: 'paymentProvider' },
    { header: 'Created', accessorKey: 'createdAt' },
  ]

  return (
    <Box p={4}>
      <Heading level={2} mb={3}>
        Pending Everee Payments
      </Heading>
      <Heading level={3} mb={3}>
        ({new Date().toLocaleString('en-US')})
      </Heading>
      {isLoading ? <Text>Loading…</Text> : null}
      {error ? <Text color="error">Failed to load data</Text> : null}
      {!isLoading && !error ? (
        <Table columns={columns} data={data} enableSorting />
      ) : null}
    </Box>
  )
}
